module.exports = __webpack_public_path__ + "selwebee_tom_toybox-71581cb0a01fec3cde47d66fc055f294.png";